import React from 'react';
import {
    Box,
    Typography,
    Modal,
    Select,
    Button,
    TextField,
    FormControl,
    MenuItem,
    IconButton,
    InputLabel,
    InputAdornment,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SingleSelectDroupdown from '../../../components/Projects/project-components/SingleSelectDroupdown';
import SingleDateWithoutArrow from '../../../components/Date-range-picker/SingleDateWithoutArrow';
import TimelineBar from './TimelineBar';
import TimeLabels from './TimeLabels';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const hoursToTimeString = (hours) => {
    const hour = Math.floor(hours);
    const minute = Math.round((hours - hour) * 60);
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minute.toString().padStart(2, '0')} ${period}`;
};

const timeStringToHours = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    return hours + (minutes / 60);
};

const AddTimeModal = ({
    modalOpen,
    closeModal,
    handleAddEntry,
    newStart,
    setNewStart,
    newEnd,
    setNewEnd,
    newType,
    setNewType,
    data,
    currentTime,
    ACTIVITIES,
    options,
    toggleOption,
    selectedProject,
    setSelectedProject,
}) => {
    const [startTime, setStartTime] = React.useState(hoursToTimeString(newStart));
    const [endTime, setEndTime] = React.useState(hoursToTimeString(newEnd));
    const [otherReason, setOtherReason] = React.useState('');

    const handleStartTimeChange = (e) => {
        const timeStr = e.target.value;
        setStartTime(timeStr);
        try {
            const hours = timeStringToHours(timeStr);
            setNewStart(hours);
        } catch {
            console.error('Invalid time format');
        }
    };

    const handleEndTimeChange = (e) => {
        const timeStr = e.target.value;
        setEndTime(timeStr);
        try {
            const hours = timeStringToHours(timeStr);
            setNewEnd(hours);
        } catch {
            console.error('Invalid time format');
        }
    };

    const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/i;
    const [age, setAge] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    return (
        <Modal open={modalOpen} onClose={closeModal} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Box display="flex" alignItems="center" sx={{ gap: '12px' }}>
                        <img src="./assets/images/insights/file/add-time-icon.svg" alt='add time' className="img-fluid" />
                        <Box>
                            <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Add time</Typography>
                        </Box>
                    </Box>

                    <IconButton onClick={closeModal} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <InputLabel className="text-sm mx-0 mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 0 4px', display: 'block', fontFamily: 'Manrope' }}>Project*</InputLabel>
                    </Box>

                    <SingleSelectDroupdown
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                    />
                    <Box sx={{ margin: '24px auto ' }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Time Span (IST)*</InputLabel>

                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                            <Box sx={{ width: '100%' }}><SingleDateWithoutArrow /></Box>
                            <Box sx={{ '& .MuiFormControl-root': { margin: '0' } }}>
                                <TextField
                                    value={startTime}
                                    onChange={handleStartTimeChange}
                                    fullWidth
                                    margin="dense"
                                    placeholder="Start Time (e.g., 9:00 AM)"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccessTimeIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            height: '38px',
                                            padding: '0 14px',
                                            fontSize: '14px',
                                            color: '#64748B',
                                            width: '140px',
                                            fontFamily: 'Manrope',
                                            borderRadius: '8px',
                                        },
                                    }}
                                    error={!timeFormatRegex.test(startTime)}
                                    helperText={!timeFormatRegex.test(startTime) ? 'Format: HH:MM AM/PM' : ''}
                                />
                            </Box>
                            <Box sx={{ '& .MuiFormControl-root': { margin: '0' } }}>
                                <TextField
                                    value={endTime}
                                    onChange={handleEndTimeChange}
                                    fullWidth
                                    margin="dense"
                                    placeholder="End Time (e.g., 5:30 PM)"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccessTimeIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            height: '38px',
                                            padding: '0 14px',
                                            fontSize: '14px',
                                            color: '#64748B',
                                            width: '140px',
                                            fontFamily: 'Manrope',
                                            borderRadius: '8px',
                                        },
                                    }}
                                    error={!timeFormatRegex.test(endTime)}
                                    helperText={!timeFormatRegex.test(endTime) ? 'Format: HH:MM AM/PM' : ''}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ margin: '24px auto 8px' }}>
                        <Typography sx={{ fontSize: '12px', color: '#64748B', textAlign: 'center', margin: '0 auto 4px', fontFamily: 'Manrope' }}>
                            {hoursToTimeString(newStart)} - {hoursToTimeString(newEnd)}
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', textAlign: 'center', fontWeight: '600', fontFamily: 'Manrope' }}>
                            {((newEnd - newStart) * 60).toFixed(0)} minutes
                        </Typography>
                    </Box>

                    <TimelineBar
                        data={data}
                        currentTime={currentTime}
                        handleMouseMove={() => { }}
                        handleMouseLeave={() => { }}
                        hoverTime={null}
                        plusPosition={null}
                        openModal={() => { }}
                        ACTIVITIES={ACTIVITIES}
                    />

                    <TimeLabels interval={8} />

                    <ul>
                        <li className="cursor-pointer" style={{ margin: '24px auto', fontFamily: 'Manrope', }} >
                            <input type="checkbox" className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#64748B', lineHeight: '2' }}>Billable</span>
                        </li>
                    </ul>

                    <Box>


                    </Box>

                    <Box sx={{ backgroundColor: '#FFF3DE', borderRadius: '10px', padding: '10px 16px', margin: '24px auto', fontFamily: 'Manrope' }}>
                        <Typography fontSize="16px" fontWeight="600" color="#E69805" sx={{ fontFamily: 'Manrope' }}>This is 8:00 pm - 9:00 pm in Ram Rajan's time zone.</Typography>
                    </Box>

                    <Box sx={{ mt: 3 }}>
                        <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', mb: '4px', fontFamily: 'Manrope' }}>Reason*</Typography>
                        <Select sx={{ width: '100%', borderRadius: '8px', height: '40px' }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={age}
                            // label="Age"
                            onChange={handleChange}
                        >

                            <MenuItem value={10}>Focus</MenuItem>
                            <MenuItem value={20}>Break</MenuItem>
                            <MenuItem value={30}>Meeting</MenuItem>
                            <MenuItem value={40}>Ideas</MenuItem>
                            <MenuItem value={50}>Manual</MenuItem>
                        </Select>
                    </Box>
                    {newType === 'other' && (
                        <Box sx={{ mt: 2 }}>
                            <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', mb: '4px', fontFamily: 'Manrope' }}>Please specify</Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                placeholder="Why are you editing this time entry?"
                                value={otherReason}
                                onChange={(e) => setOtherReason(e.target.value)}
                                sx={{
                                    fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                    }, '& .MuiInputBase-input': {
                                        fontFamily: 'Manrope',
                                        fontSize: '14px',
                                        color: '#1A1F36',
                                        lineHeight: 1.5,

                                    },
                                }}
                            />
                        </Box>
                    )}

                    <Box mt={3}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', mb: '4px', fontFamily: 'Manrope' }}>Note</Typography>
                        <TextField fullWidth multiline rows={3} placeholder="What were you working on?" sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            },
                            '& .MuiInputBase-input': {
                                fontFamily: 'Manrope',
                                fontSize: '14px',
                                color: '#1A1F36',
                                lineHeight: 1.5,
                            },
                        }}
                        />

                    </Box>
                </Box>

                {/* Footer */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={closeModal} variant="outlined" sx={{ height: '50px', fontFamily: 'Manrope' }}>Cancel</Button>
                    <Button
                        onClick={() => {
                            const reason = newType === 'other' ? otherReason : ACTIVITIES[newType]?.label;
                            handleAddEntry({ reason });
                        }}
                        variant="contained"
                        sx={{ height: '50px', fontFamily: 'Manrope' }}
                        disabled={!timeFormatRegex.test(startTime) || !timeFormatRegex.test(endTime)}
                    >
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddTimeModal;
